// libraries
import React from "react";
import pluralize from "pluralize";
import { useDispatch } from "react-redux";

// util
import { url } from "@clockwise/client-commons/src/constants/site";
import { setPricingDialogOpen } from "@actions/payments.actions";
import { TrackingEvents, track } from "@clockwise/web-commons/src/util/analytics.util";

// material-ui
import { Info, ArrowUpward } from "@material-ui/icons";

const stylingForBanner = {
  gray: {
    iconColor: "cw-fill-gray-500",
    textColor: "cw-text-gray-500",
    backgroundColor: "cw-bg-[#EFF2F5]",
  },
  blue: {
    iconColor: "cw-fill-white",
    textColor: "cw-text-white",
    backgroundColor: "cw-bg-[#23A7BC]",
  },
  red: {
    iconColor: "cw-fill-white",
    textColor: "cw-text-white",
    backgroundColor: "cw-bg-[#CF7A58]",
  },
};

export const TrialBannerSideMenu = ({ daysLeft }: { daysLeft: number | null }) => {
  const dispatch = useDispatch();

  if (!daysLeft || daysLeft <= 0) return null;

  let status: "gray" | "blue" | "red" = "gray";
  if (daysLeft <= 5) {
    status = "red";
  } else if (daysLeft > 15) {
    status = "gray";
  } else {
    status = "blue";
  }

  const onSelectUpgrade = () => {
    track(TrackingEvents.PAYWALLS.SIDEMENU_TRIAL_BANNER_UPGRADE_CLICKED, { daysLeft: daysLeft });
    if (daysLeft > 5) {
      dispatch(setPricingDialogOpen(true));
    } else {
      window.open(`${url}/app/checkout`, "_blank", "noopener,noreferrer");
    }
  };

  return (
    <div
      className={`${stylingForBanner[status].backgroundColor} ${stylingForBanner[status].textColor} cw-w-full cw-py-2 cw-px-1 cw-font-bold cw-text-[11px] cw-flex cw-items-center cw-justify-between`}
    >
      <div className="cw-flex cw-items-center cw-gap-1">
        <Info className={`${stylingForBanner[status].iconColor} cw-w-4 cw-h-4 cw-ml-2`} />
        <span>{`${daysLeft} ${pluralize("day", daysLeft)} left in Pro plan trial`}</span>
      </div>
      <span
        onClick={onSelectUpgrade}
        className={`cw-flex cw-no-underline cw-items-center cw-gap-1 cw-cursor-pointer hover:cw-underline`}
      >
        UPGRADE
        <ArrowUpward
          className={`${stylingForBanner[status].iconColor} cw-w-4 cw-h-4 cw-rotate-45`}
        />
      </span>
    </div>
  );
};
